import {
  POST_TARGET,
  PRE_ACTIVATION_EDIT_TARGET,
  REMOVE_TARGET_FROM_TARGET_LIST,
  UPDATE_TARGET,
  CREATE_TARGET,
  SET_LOADING_VALUE,
  SET_ACTIVATION_FAILED,
  CHANGED_ON_FILTER,
  REFRESH_TARGET_LIST,
  ADD_TARGET_TO_TARGET_LIST,
  FORECAST_TARGET_TO_TARGET_LIST,
  TOGGLE_TARGET_ARCHIVE_STATE,
  UPDATE_TARGET_TO_TARGET_LIST,
  SET_REFRESH_TABLE_FLAG,
  REPLACE_TARGET,
  SET_TARGET_STATUS,
  SET_LAS_DATA_AVAILABLE,
  SET_COLUMN_FILTERS,
  REMOVE_COLUMN_FILTER_VALUES,
} from './actions'
import { targetRouteHandler } from '@/helpers'
import router from '@/router'
import { EventBus } from '@/api/eventBus'
import { tableMap } from '@/router/tableMap.js'
import { ACTIVATION_STATUS, TARGET_TYPES_INTEGERS } from '@/appLogic/targets/Constants'

const mutations = {
  [CHANGED_ON_FILTER](state, previousFilter) {
    state.previousFilter = previousFilter
  },
  [POST_TARGET](state, target) {
    const currentTarget = state.targets.find(t => t.id === target.id && t.target === target.target)
    if (currentTarget) {
      Object.assign(currentTarget, target)
    }
    // router.push({ name: 'user-target-manager', params: { name: target.username } })
  },
  [PRE_ACTIVATION_EDIT_TARGET](state, { originalTarget, newTarget }) {
    const target = state.targets.find(t => t.id === originalTarget.id && t.target === originalTarget.target)
    if (target) {
      Object.assign(target, newTarget)
    }
    targetRouteHandler('CONFIRM-ACTIVATION', originalTarget)
  },
  [REMOVE_TARGET_FROM_TARGET_LIST](state, target) {
    const idx = state.targets.findIndex(t => t.id === target.id && t.target === target.target)

    if (idx > -1) {
      state.targets.splice(idx, 1)
    }
  },
  [ADD_TARGET_TO_TARGET_LIST](state, target) {
    if (target.last_update_str && target.created_str) {
      target.last_update = target.last_update_str
      target.created = target.created_str
    }
    target.activation_date_str && (target.activation_date = target.activation_date_str)
    target.last_posting_str && (target.last_posting = target.last_posting_str)
    // we'll need this until we've fully moved over to unified 'targets' table w/ proper JSONB columns
    try {
      target.advertiser = JSON.parse(target.advertiser)
      let brand = target.brand ? target.brand.name : null
      target.advertiserBrand = target.advertiser ? target.advertiser.Name : brand
    } catch (e) {
      let brand = target.brand ? target.brand.name : null
      target.advertiserBrand = target.advertiser ? target.advertiser.Name : brand
    }
    state.targets.push(target)
  },
  [FORECAST_TARGET_TO_TARGET_LIST](state, targetId) {
    const selected_target = state.targets.filter(t => t.id === targetId)
    if (selected_target.length > 0) {
      const isNPower = selected_target[0].target_type === TARGET_TYPES_INTEGERS.NPOWER
      const isComscore = selected_target[0].target_type === TARGET_TYPES_INTEGERS.COMSCORE
      if (isNPower || isComscore) {
        selected_target[0].activation_status = ACTIVATION_STATUS.WORKING
      } else {
        selected_target[0].activation_status = ACTIVATION_STATUS.LIVE
      }
    }
  },
  [UPDATE_TARGET_TO_TARGET_LIST](state, target) {
    const selected_target = state.targets.filter(t => t.id === target.id)[0]
    for (const key of Object.keys(target)) {
      selected_target[key] = target[key]
    }
  },
  [REFRESH_TARGET_LIST](state) {
    state.targets = [].concat(state.targets)
  },
  [TOGGLE_TARGET_ARCHIVE_STATE](state, target) {
    target.archived = !target.archived
  },
  [UPDATE_TARGET](state, { id, updatedTarget }) {
    const index = state.targets.findIndex(t => t.id === id)
    if (index === -1) return

    if (updatedTarget.last_update_str && updatedTarget.created_str) {
      updatedTarget.last_update = updatedTarget.last_update_str
      updatedTarget.created = updatedTarget.created_str
    }
    try {
      updatedTarget.advertiser = JSON.parse(updatedTarget.advertiser)
      let brand = updatedTarget.brand ? updatedTarget.brand.name : null
      updatedTarget.advertiserBrand = updatedTarget.advertiser ? updatedTarget.advertiser.Name : brand
    } catch (e) {
      let brand = updatedTarget.brand ? updatedTarget.brand.name : null
      updatedTarget.advertiserBrand = updatedTarget.advertiser ? updatedTarget.advertiser.Name : brand
    }
    updatedTarget.activation_date_str && (updatedTarget.activation_date = updatedTarget.activation_date_str)
    updatedTarget.last_posting_str && (updatedTarget.last_posting = updatedTarget.last_posting_str)
    state.targets[index] = updatedTarget
    state.targets = [].concat(state.targets)
  },
  [REPLACE_TARGET](state, target) {
    EventBus.$emit('update-target', target.id, target)
    // DEPRECATED with the use of ServerSideDatasource feature of ag-grid
    // state.targets = state.targets.map(t => {
    //   if (t.id === target.id) {
    //     return {
    //       ...t,
    //       ...target
    //     }
    //   } else {
    //     return t
    //   }
    // })
  },
  [CREATE_TARGET](state, target) {
    state.targets.push(target)
    router.push({ name: tableMap[target.target], params: { id: target.id } })
  },
  [SET_LOADING_VALUE](state, value) {
    state.loading = value
  },
  [SET_REFRESH_TABLE_FLAG](state, value) {
    state.refreshTable = value
  },
  [SET_ACTIVATION_FAILED](state, value) {
    state.activatedFailed = value
  },
  [SET_TARGET_STATUS](state, target) {
    const index = state.targets.findIndex(t => t.id === target.id)
    if (index === -1) return
    state.targets[index].activation_status = target.activationStatus
    state.targets[index].last_update = new Date(target.last_update).toLocaleTimeString('en-US')
  },
  [SET_LAS_DATA_AVAILABLE](state, value) {
    state.lasDataAvailable = value
  },
  [SET_COLUMN_FILTERS](state, value) {
    let columnFiltersFromState =
      state.columnFilters && Object.keys(state.columnFilters).length > 0
        ? state.columnFilters
        : JSON.parse(localStorage.getItem('DASHBOARD_COLUMN_FILTER_VALUES'))
    localStorage.setItem('DASHBOARD_COLUMN_FILTER_VALUES', JSON.stringify({ ...columnFiltersFromState, ...value }))
    state.columnFilters = { ...columnFiltersFromState, ...value }
  },
  [REMOVE_COLUMN_FILTER_VALUES](state) {
    localStorage.removeItem('DASHBOARD_COLUMN_FILTER_VALUES')
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/views/audienceHub/store/mutations.js